module.exports = __webpack_public_path__ + "img/offQR.dc33769b.jpg";